<template>
  <div>
    <vm-table
        ref="vmTable"
        height="62vh"
        :filter.sync="filter"
        module="basic"
        url="checkManges">
      <div slot="toolbar">
        <el-button
            slot="toolbar"
            type="primary"
            size="mini"
            @click="$refs.nonconformingProductManageEdit.open(0)">
          新建
        </el-button>
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="物料号">
            <el-input v-model.trim="filter.materialNo" clearable/>
          </vm-search>
          <vm-search label="工序">
            <el-select v-model="filter.process" clearable size="mini" placeholder="请选择">
              <el-option
                  v-for="item in constants.process.$options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"/>
            </el-select>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="process" width="150" align="center" label="工序"/>
      <el-table-column prop="materialNo" align="center" label="物料号"/>
      <el-table-column prop="status" align="center" label="状态">
        <template slot-scope="scope">
          {{scope.row.status===0 ? "无效" : "有效"}}
        </template>
      </el-table-column>
      <el-table-column
          label="操作"
          align="center"
          width="180"
          class-name="vm-table_operate">
        <template slot-scope="scope">
          <el-button v-if="scope.row.status===0 || editAuth" type="primary" @click="edit(scope.row)">编辑</el-button>
          <el-button v-if="scope.row.status===0 || editAuth" type="danger" @click="oneDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <nonconforming-product-manage-edit ref="nonconformingProductManageEdit" @save-success="getList(-1)"/>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import NonconformingProductManageEdit from "./NonconformingProductManageEdit.vue";
  import constants from "@/util/constants.js";

  export default {
    components: {NonconformingProductManageEdit, VmTable, VmSearch},
    data() {
      return {
        constants,
        editAuth: this.$auth(835),
        filter: {
          materialNo: "",
          process: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      edit(row) {
        this.$refs.nonconformingProductManageEdit.open(row);
      },
      oneDelete(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .delete("basic","checkManges",row.pkid).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
            });
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
</style>
